/* eslint-disable no-unused-vars */
//import React from "react";
// const BookingTabs = React.lazy(() =>
//   import("../views/viewBookingTable/viewBookingTabs")
// );
// const MainTabs = React.lazy(() =>
//   import("../views/CashBooking/CashBookingTabs")
// );

// const ScanedandManifestList = React.lazy(() =>
//   import("../views/viewBookingTable/ScanedandManifestList")
// );
// const ChildPacketScan = React.lazy(() =>
//   import("../views/viewBookingTable/ChildPacketScann")
// );
// const PrintManifest = React.lazy(() =>
//   import("../views/viewBookingTable/PrintManifest")
// );
// const AddPacketMapping = React.lazy(() =>
//   import("../views/Master/PacketingGuide/AddPacketMapping")
// );
// const ViewManifest = React.lazy(() => import("../views/ViewManifest"));
// const Truck = React.lazy(() => import("../views/viewBookingTable/Truck"));
// const AddPacket = React.lazy(() =>
//   import("../views/viewBookingTable/Addpacket")
// );
// const Calculator = React.lazy(() => import("../views/Calculater"));
// const BookedSuccessfull = React.lazy(() =>
//   import("../views/BookSuccessfull/index")
// );
// const Broadcast = React.lazy(() =>
//   import("../views/Broadcast")
// );
// const Master = React.lazy(() =>
//   import("../views/Master")
// );
// const CashbookingRateCard = React.lazy(() =>
//   import("../views/Master/RateCard/CashbookingRateCard")
// );
// const AllocateTemplate = React.lazy(() =>
//   import("../views/Master/RateCard/CashbookingRateCard/allocateTemplate")
// );
// const Pincode = React.lazy(() =>
//   import("../views/Master/PincodeMaster")
// );
// const CpOnbordingTabs = React.lazy(() =>
//   import("../views/Master/CpOnbordingTabs")
// );
// const RouteMaster = React.lazy(() =>
//   import("../views/Master/Route")
// );
// const FirstAndLastMileTAT = React.lazy(() =>
//   import("../views/Master/TAT/FirstAndLastMile")
// );
// const VehicleOnboard = React.lazy(() =>
//   import("../views/Master/VehicleOnboard")
// );
// const MiddleMileTAT = React.lazy(() =>
//   import("../views/Master/TAT/middleMile")
// );
// const MasterChild = React.lazy(() =>
//   import("../views/Master/RateCard/masterChild")
// );
// const PacketingGuide = React.lazy(() =>
//   import("../views/Master/PacketingGuide")
// );
// const PinCodeMapping = React.lazy(() =>
//   import("../views/Master/PinCodeMapping")
// );
import MainTabs from "../views/CashBooking/CashBookingTabs";
import BookingTabs from "../views/viewBookingTable/viewBookingTabs";
import ScanedandManifestList from "../views/viewBookingTable/ScanedandManifestList";
import ChildPacketScan from "../views/viewBookingTable/ChildPacketScann";
import PrintManifest from "../views/viewBookingTable/PrintManifest";
import AddPacketMapping from "../views/Master/PacketingGuide/AddPacketMapping";
import ViewManifest from "../views/ViewManifest";
import Calculator from "../views/Calculater";
import Truck from "../views/viewBookingTable/Truck";
import AddPacket from "../views/viewBookingTable/Addpacket";
import BookedSuccessfull from "../views/BookSuccessfull/index";
import Master from "../views/Master";
import CashbookingRateCard from "../views/Master/RateCard/CashbookingRateCard";
import AllocateTemplate from "../views/Master/RateCard/CashbookingRateCard/allocateTemplate";
import PincodeMaster from "../views/Master/PincodeMaster";
import CpOnbordingTabs from "../views/Master/CpOnbordingTabs";
import RouteMaster from "../views/Master/Route";
import FirstAndLastMileTAT from "../views/Master/TAT/FirstAndLastMile";
import VehicleOnboard from "../views/Master/VehicleOnboard";
import MiddleMileTAT from "../views/Master/TAT/middleMile";
import MasterChild from "../views/Master/RateCard/masterChild";
import PacketingGuide from "../views/Master/PacketingGuide";
import PinCodeMapping from "../views/Master/PinCodeMapping";
import ViewDetails from "../views/Master/CpOnbordingSteps/ViewDetails";
import GlobalSetting from "../views/GlobalSettings";
import {
  MiddleMileSubRoutes,
  MiddleMileHubScan,
  Configuration,
  Stationary,
  LastMileOperations,
} from "../views/middleMileSubRoutes";

import Broadcast from "../views/Broadcast";
import HubOnboarding from "../views/Master/HubOnboard";
import AuditTabs from "../views/MiddleMileOperations/Audit";

import OnborginTabs from "../views/Onbording";
import AccountBookingTabs from "../views/AccountBooking";
import AccountTabs from "../views/AccountBookingPage";
import SortingGuide from "../views/Master/SortingGuide";
import ClientOnboarding from "../views/onboarding_/ClientOnboarding";
import ClientTable from "../views/onboarding_/ClientOnboarding/viewClientTable";
import ViewClientDetails from "../views/onboarding_/ClientOnboarding/ViewClientDetails";
import ConsolidatedManifest from "../views/MiddleMileOperations/ConsolidatedManifest(InScan)/index";
import PrintConsolidatedManifest from "../views/MiddleMileOperations/ConsolidatedManifest(InScan)/PrintConsolidatedManifest";
import StaffOnboarding from "../views/onboarding_/StaffOnboarding";
import Guides from "../views/Guides";
import Audits from "../views/Audit";
//--Middle Mile--//
import ViewTrip from "../views/MiddleMileOperations/Outscan&Lcr/ViewTrip";
import OutScan from "../views/MiddleMileOperations/Outscan&Lcr/OutScan";
import CreateTrip from "../views/MiddleMileOperations/Outscan&Lcr/CreateTrip";
import LcrList from "../views/MiddleMileOperations/Outscan&Lcr/LcrList";
import PrintLcr from "../views/MiddleMileOperations/Outscan&Lcr/PrintLcr";
import EwayUpdate from "../views/MiddleMileOperations/Outscan&Lcr/EwayUpdate";
import ManifestList from "../views/MiddleMileOperations/ManifestList/index";
// import InScan from "../views/MiddleMileOperations/InScan";
// import AllManifestInScan from "../views/MiddleMileOperations/InScan/manifestInscan";

import CreateOrUpdateTrip from "../views/MiddleMileOperations/Outscan&Lcr/CreateOrUpdateTrip";
import UpdateTripList from "../views/MiddleMileOperations/Outscan&Lcr/UpdateTripList";
import UpdateTrip from "../views/MiddleMileOperations/Outscan&Lcr/UpdateTrip";
import AuditScannedTable from "../views/MiddleMileOperations/AuditScannedTable";

import ViewSortingMM from "../views/MiddleMileOperations/Sorting";
import Packeting from "../views/MiddleMileOperations/HubPacketing";
import Bagging from "../views/MiddleMileOperations/Bagging";
//--//
import "antd/dist/antd.css";
import "../App.scss";
import constants from "../constants/constants";
import Tracker from "../views/MiddleMileOperations/Tracker";

//
import LCRBagInScan from "../views/MiddleMileOperations/BagScannig";

// import OpenBag from "../views/MiddleMileOperations/OpenBag";

import LCRListScan from "../views/MiddleMileOperations/LCRInScanList";

// import LcrPacketsInScan from "../views/MiddleMileOperations/LCRPackets";
import HoStationary from "../views/HoStationary";
import AddCategory from "../views/HoStationary/AddCategory/inedx";
import AddProduct from "../views/HoStationary/AddProduct";
import ProductCP from "../views/CPStationary/Product";
import ProductDetails from "../views/CPStationary/Product/productDetails";
import ScannedBags from "../views/MiddleMileOperations/OpenLCRBags";

import BagContents from "../views/MiddleMileOperations/OpenLCRBags/bagContent";

import PacketContents from "../views/MiddleMileOperations/OpenPackets/packetContent";
import SortToCp from "../views/MiddleMileOperations/SortToCp";

import ScannedPacket from "../views/MiddleMileOperations/OpenPackets";
import ProductTabs from "../views/HoStationary/productTabs";
import CartPage from "../views/CPStationary/Cart";
import OrderRequest from "../views/HoStationary/OrderRequest";
import OrderHistory from "../views/CPStationary/Order";
import OrderDetails from "../views/CPStationary/Order/orderDetails";
import DrsGeneration from "../views/LastMileOperations/DrsGeneration/index";
// import GenerateManifest from "../views/GenerateManifest";
import GenerateManifestTabs from "../views/GenerateManifestTabs";

//lastMile

import InScanCP from "../views/LastMileOperations/InScanCP";
import CreateVirtualArea from "../views/LastMileOperations/VirtualArea";
// import CreateVirtualArea from "../views/LastMileOperations/CreateVirtualArea";
import DrsDetails from "../views/LastMileOperations/DrsGeneration/DrsDetails";
import printDrs from "../views/LastMileOperations/DrsGeneration/printDrs";
import PrintGenerateManifest from "../views/PrintGenerateManifest";
import PendingDrs from "../views/LastMileOperations/PendingDrs/PendingDrs";

import ExcesInscan from "../views/ExcesInscan";

const { ROLES } = constants;
const { CP_ADMIN, HO_ADMIN, HUB_ADMIN } = ROLES;

export const routeList = [
  {
    component: BookingTabs,
    route: "/viewBooking",
    role: [CP_ADMIN],
  },
  {
    component: MainTabs,
    route: "/cash-booking",
    role: [CP_ADMIN],
  },
  {
    component: ScanedandManifestList,
    route: "/scan",
    role: [CP_ADMIN],
  },
  {
    component: ChildPacketScan,
    route: "/child-scan",
    role: [CP_ADMIN],
  },
  {
    component: PrintManifest,
    route: "/print",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN],
  },
  {
    component: LastMileOperations,
    route: "/last-mile-operations",
    role: [CP_ADMIN],
  },
  {
    component: InScanCP,
    route: "/in-scan-cp",
    role: [CP_ADMIN],
  },
  {
    component: CreateVirtualArea,
    route: "/create-virtual-area",
    role: [CP_ADMIN],
  },
  {
    component: AddPacketMapping,
    route: "/addpacket-mapping",
    role: [HO_ADMIN],
  },
  {
    component: ViewManifest,
    route: "/view-manifest",
    role: [CP_ADMIN],
  },
  {
    component: Truck,
    route: "/truck",
    role: [CP_ADMIN],
  },
  {
    component: AddPacket,
    route: "/viewBooking-packet",
    role: [CP_ADMIN],
  },
  {
    component: Calculator,
    route: "/calculater",
    role: [CP_ADMIN],
  },
  {
    component: BookedSuccessfull,
    route: "/booking-success",
    role: [CP_ADMIN],
  },
  {
    component: Master,
    route: "/masters",
    role: [HO_ADMIN],
  },
  {
    component: CashbookingRateCard,
    route: "/cash-booking-ratecard",
    role: [HO_ADMIN],
  },
  {
    component: AllocateTemplate,
    route: "/allocate-template",
    role: [HO_ADMIN],
  },
  {
    component: RouteMaster,
    route: "/route-configuration",
    role: [HO_ADMIN],
  },
  {
    component: FirstAndLastMileTAT,
    route: "/first-last-mile-tat",
    role: [HO_ADMIN],
  },
  {
    component: PincodeMaster,
    route: "/pincode-master",
    role: [HO_ADMIN],
  },
  {
    component: CpOnbordingTabs,
    route: "/cp-onbording",
    role: [HO_ADMIN, CP_ADMIN],
  },
  {
    component: VehicleOnboard,
    route: "/vehicle-onboard",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: MiddleMileTAT,
    route: "/middle-mile-tat",
    role: [HO_ADMIN],
  },
  {
    component: MasterChild,
    route: "/master-card-child",
    role: [HO_ADMIN],
  },
  {
    component: PacketingGuide,
    route: "/packeting-guide",
    role: [HO_ADMIN],
  },
  {
    component: PinCodeMapping,
    route: "/pin-code-mapping",
    role: [HO_ADMIN],
  },

  // {
  //   component: ViewDetails,
  //   route: "/view-details",
  //   // role: [HO_ADMIN, CP_ADMIN],
  // },
  {
    component: Broadcast,
    route: "/message-and-alerts",
    role: [HO_ADMIN],
  },
  {
    component: GlobalSetting,
    route: "/onboarding-settings",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN],
  },
  {
    component: Stationary,
    route: "/stationery",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN],
  },
  {
    component: MiddleMileSubRoutes,
    route: "/middle-mile",
    role: [HUB_ADMIN],
  },
  {
    component: MiddleMileHubScan,
    route: "/hub-in-scan",
    role: [HUB_ADMIN],
  },
  {
    component: Configuration,
    route: "/configuration-guide",
    role: [HUB_ADMIN],
  },
  {
    component: Guides,
    route: "/guides",
    role: [HUB_ADMIN],
  },
  {
    component: CreateOrUpdateTrip,
    route: "/create-or-update-trip",
    role: [HUB_ADMIN],
  },
  {
    component: ManifestList,
    route: "/manifest-list",
    role: [HUB_ADMIN, CP_ADMIN],
  },

  {
    component: UpdateTripList,
    route: "/update-trip-list",
    role: [HUB_ADMIN],
  },
  {
    component: UpdateTrip,
    route: "/update-trip",
    role: [HUB_ADMIN],
  },
  {
    component: Audits,
    route: "/audits",
    role: [HUB_ADMIN],
  },
  {
    component: HubOnboarding,
    route: "/hub-onboarding",
    role: [HO_ADMIN],
  },
  {
    component: OnborginTabs,
    route: "/cp-onboarding",
    role: ["ROLE_HOADMIN"],
  },
  {
    component: AccountBookingTabs,
    route: "/account-booking",
    role: [CP_ADMIN],
  },
  {
    component: SortingGuide,
    route: "/sorting-guide",
    role: [HO_ADMIN, HUB_ADMIN],
  },
  {
    component: ClientOnboarding,
    route: "/client-onboarding",
    role: [CP_ADMIN],
  },
  {
    component: ClientTable,
    route: "/client-list",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: ViewClientDetails,
    route: "/view-client/:id",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: StaffOnboarding,
    route: "/staff-onboarding",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN],
  },
  {
    component: AuditTabs,
    route: "/manifest-audit",
    role: [HUB_ADMIN],
  },
  {
    component: DrsGeneration,
    route: "/generate-drs",
    role: [CP_ADMIN],
  },
  {
    component: printDrs,
    route: "/print-drs",
    role: [CP_ADMIN],
  },
  {
    component: DrsDetails,
    route: "/drs-details",
    role: [CP_ADMIN],
  },
  {
    component: PendingDrs,
    route: "/pending-drs",
    role: [CP_ADMIN],
  },
  {
    component: AccountTabs,
    route: "/account",
    role: [HO_ADMIN, CP_ADMIN],
  },

  //--Middle Mile--//
  // {
  //   component: InScan,
  //   route: "/in-scan/:id",
  //   // route: "/manifest-in-scan",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   component: AllManifestInScan,
  //   route: "/manifest-in-scan",
  //   // route: "/manifest-in-scan",
  //   role: [HUB_ADMIN],
  // },
  {
    component: AuditScannedTable,
    // route: "/in-scan",
    route: "/audit-scanned",
    role: [HUB_ADMIN],
  },
  {
    component: Packeting,
    route: "/packeting",
    role: [HUB_ADMIN],
  },
  {
    component: ViewSortingMM,
    route: "/sort-shipment",
    role: [HUB_ADMIN],
  },
  {
    component: Tracker,
    route: "/manifest-tracker/:id",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN],
  },
  { component: Bagging, route: "/bagging", role: [HUB_ADMIN] },
  // deepak's rout

  {
    component: ViewTrip,
    route: "/view-trip",
    role: [HUB_ADMIN],
  },
  { component: OutScan, route: "/outscan", role: [HUB_ADMIN] },
  { component: CreateTrip, route: "/create-trip", role: [HUB_ADMIN] },
  { component: Bagging, route: "/shipment-bagging", role: [HUB_ADMIN] },
  {
    component: LcrList,
    route: "/lcr-list",
    role: [HUB_ADMIN],
  },
  {
    component: PrintLcr,
    route: "/print-lcr",
    role: [HUB_ADMIN],
  },
  {
    component: ConsolidatedManifest,
    route: "/consolidated-manifest",
    role: [HUB_ADMIN],
  },
  {
    component: PrintLcr,
    route: "/print-lcr",
    role: [HUB_ADMIN],
  },
  {
    component: EwayUpdate,
    route: "/eway-update/:tripId",
    role: [HUB_ADMIN],
  },
  {
    component: PrintConsolidatedManifest,
    route: "/print-consolidated-manifest/:id",
    role: [HUB_ADMIN],
  },
  //--//

  {
    component: LCRBagInScan,
    route: "/lcr-bag-scan/:id",
    role: [HUB_ADMIN],
  },

  // {
  //   component: OpenBag,
  //   route: "/lcr-bag-open/:id",
  //   role: [HUB_ADMIN],
  // },
  {
    component: LCRListScan,
    route: "/lcr-list-in-scan",
    role: [HUB_ADMIN],
  },

  {
    component: ScannedBags,
    route: "/lcr-scanned-bags",
    role: [HUB_ADMIN],
  },
  {
    component: SortToCp,
    route: "/sort-to-cp",
    role: [HUB_ADMIN],
  },

  //stationary
  // {
  //   component: HoStationary,
  //   route: "/stationery",
  //   role: [HO_ADMIN],
  // },
  {
    component: AddCategory,
    route: "/add-category",
    role: [HO_ADMIN],
  },
  {
    component: AddProduct,
    route: "/add-product",
    role: [HO_ADMIN],
  },
  {
    component: ProductTabs,
    route: "/product",
    role: [HO_ADMIN],
  },
  {
    component: BagContents,
    route: "/bag-contents/:id",
    role: [HUB_ADMIN],
  },
  {
    component: ScannedPacket,
    route: "/scan-packets",
    role: [HUB_ADMIN],
  },
  {
    component: PacketContents,
    route: "/packet-contents/:id",
    role: [HUB_ADMIN],
  },
  {
    component: ProductCP,
    route: "/product-list",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: ProductDetails,
    route: "/product-details/:id",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: CartPage,
    route: "/cart-details",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: OrderRequest,
    route: "/order-request",
    role: [HO_ADMIN],
  },
  {
    component: OrderHistory,
    route: "/order-history",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: OrderDetails,
    route: "/order-details/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: GenerateManifestTabs,
    route: "/generateManifest",
    role: [HUB_ADMIN],
  },
  {
    component: PrintGenerateManifest,
    route: "/print-generate-manifest/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: ExcesInscan,
    route: "/excess-inscan",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
];

// import  from "../views/MiddleMileOperations/LCRList";

// import LcrPackets from "../views/MiddleMileOperations/LCRList";
